import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./Contact.module.css";
import Navbar from "../../components/Navbar/Navbar";
import RookTech from "../../images/rook-no-bg.png";
import { FaLinkedin } from "react-icons/fa";
import Footer from "../../components/Footer/Footer";

const ContactPage = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.pageWrapper}>
      <Navbar />
      <main className={styles.contactMain}>
        <img
          className={styles.towerBackground}
          src={RookTech}
          alt="Rook Tech Background"
        />

        <section className={styles.contactBox}>
          <h2 className={styles.contactTitle}>{t("contact.title")}</h2>
          <p className={styles.contactText}>{t("contact.text")}</p>

          <div className={styles.iconContainer}>
            <a
              className={styles.contactIconLinkedin}
              href="https://www.linkedin.com/company/rook-tech-llc/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedin size={40} />
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;
